import React, {PureComponent} from 'react';
import HigSideNav from '@hig/side-nav';
import {routesProvider} from '../../config/app-config';
import Icons from './SideNavIcons';
import Module from './SideNavModule';
import Submodule from './SideNavSubModule';
import Auth from '../../scripts/auth';
import {userAuthContext} from '../../context/userAuthContext';

const {Group} = HigSideNav;
const {sections, pages, basename} = routesProvider;

// State Resetters
const resetSubmodules = pages.reduce(
  (acc, page) => ({...acc, [page.id]: false}), {});
const resetModules = Object.keys(sections).reduce(
  (acc, sec) => ({...acc, [sec]: false}), {});

class Groups extends PureComponent {
  state = {
    expand: false,
    subActive: false,
    modActive: false,
    submodulesActivationList: {
      'online-prices-product': false,
      'offerings': false,
      'online-prices-sap-region': false,
      'online-prices-purchase-type': false,
      'online-prices-consumer-application': false,
      'online-prices-consumer-application-country': false,
      'online-promotions': false,
      'online-prices-payment-method': false,
      'online-prices-product-language-pack': false,
      'online-prices-consumer-application-country-payment': false,
      'language-packs': false,
      'product-purchase-type': false,
      'reseller-affiliate-submissions': false,
      'product-catalogue-products': false,
      'product-catalogue-localized-properties': false,
      'product-catalogue-cloudrelease': false,
      'google-shopping-products': false,
      'google-shopping-store-configuration': false,
      'online-prices-cloud-credit': false,
      'sales-contact-numbers-per-country-product': false,
      'sales-contact-numbers-per-country': false,
      'seo-image-repository': false
    },
    modulesActivationList: {
      'onlinePrices': false,
      'onlinePromotions': false,
      'resellerAffiliates': false,
      'googleShopping': false,
      'productCatalogue': false,
      'salesContact': false,
      'searchEngineOptimization': false
    }
  }

  handleClick(key, target) {
    if (target === "module") {
      this.setState({
        modActive: !this.state.modActive,
        modulesActivationList: {
          ...this.state.modulesActivationList,
          ...resetModules, [key]: !this.state.modActive
        }
      });
    } else {
      this.setState({
        submodulesActivationList: {
          ...this.state.submodulesActivationList,
          ...resetSubmodules,
          [key]: !this.state.subActive
        }
      });
    }
  }

  checkPagePermissions(sectionKey, context) {
    if (context && sectionKey && !context[sectionKey]) {
      return 'pda-section-disabled';
    }
    return '';
  }

  // If the current login session is BASIC, then logout BASIC
  logout(context) {
    if (context.state.currentLoginSession === "BASIC") {
      Auth.logout();
    } else { // Else logout SAML
      Auth.logoutSaml();
    }
  }

  isActive(key, target) {
    return target === "module" ? this.state.modulesActivationList[key]
      : this.state.submodulesActivationList[key];
  }

  render() {
    return (
      <userAuthContext.Consumer>
        {(context) => {
          return (
            <Group key="pda-group">
              {
                Object.keys(sections).map((sectionKey) => {
                  const Icon = Icons[sectionKey];
                  return (

                    <div key={sectionKey}
                         className={`pda-section-${sectionKey} ${this.checkPagePermissions(
                           sectionKey,
                           context?.state?.allowedServices)}`}
                    >
                      <Module
                        title={sections[sectionKey].title}
                        icon={<Icon/>}
                        activeChildren={this.isActive(
                          sectionKey,
                          'module')}
                        active={this.isActive(
                          sectionKey, 'module')}
                        onClickTitle={this.handleClick.bind(
                          this,
                          sectionKey, 'module')}
                        minimized={!this.isActive(
                          sectionKey, 'module')}
                      >
                        {
                          pages.map(page => {
                            if (page.sectionKey
                              && page.sectionKey
                              === sectionKey) {
                              return (
                                <Submodule
                                  key={page.id}
                                  title={page.title}
                                  active={this.isActive(
                                    page.id,
                                    'submodule')}
                                  onClick={this.handleClick.bind(
                                    this,
                                    page.id,
                                    'submodule')}
                                  link={basename
                                  + page.path}
                                />
                              )
                            } else {
                              return null
                            }
                          })
                        }
                      </Module>
                    </div>
                  )
                })
              }
              <Module title="Logout"
                      onClickTitle={this.logout.bind(this,
                        context)}/>
              <Module title="WPE Help and Support"
                      link="https://www.autodesk.com"
                      target="_blank"/>
            </Group>
          )
        }}
      </userAuthContext.Consumer>
    )
  }
}

export default Groups;
